/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import { randomColor } from 'utils/color-utils';

export function changeClass() {
	$('*').each(function(i, e) { $(e).css({ 'color': randomColor()}); });
}

export function teamUp() {
	$('.zoomContent-underlay-layer2').toggleClass('team-background');
}
